import { Avatar, Button, Stack, SxProps, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { FC } from 'react';

interface IBtnProps {
  imageSrc: string;
  text: string;
  callback: () => void;
  sx?: SxProps;
  role?: string;
}

export const ButtonActionNew: FC<IBtnProps> = ({
  imageSrc,
  text,
  callback,
  sx,
  role,
}: IBtnProps) => {
  const isDesktop = useIsDesktop();
  const BtnDesktopStyle = {
    width: isDesktop ? '190px' : '100px',
    border: '1px solid',
    borderColor: 'purple2.shade_300',
    borderRadius: '12px',
    background: '#FFFFFF',
    p: isDesktop ? '16px 24px' : '24px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    height: isDesktop ? undefined : '100px',
    ...sx,
  };

  return (
    <Button
      onClick={callback}
      color={'inherit'}
      sx={{
        p: '0',
      }}
      role={role}
    >
      <Stack sx={BtnDesktopStyle}>
        <Avatar
          src={imageSrc}
          alt=''
          sx={{
            width: isDesktop ? '48px' : '32px',
            height: isDesktop ? '48px' : '32px',
            mb: 1,
          }}
        />
        <Typography variant={isDesktop ? 'body3' : 'body6'}>{text}</Typography>
      </Stack>
    </Button>
  );
};
